<script>
  import ListView from '../base/ListView.vue'

  import { mapActions, mapGetters } from 'vuex'

  export default {
    components: {
      ListView,
    },
    computed: mapGetters({
      deletedItem: 'companyasset/del/deleted',
      error: 'companyasset/list/error',
      items: 'companyasset/list/items',
      isLoading: 'companyasset/list/isLoading',
      view: 'companyasset/list/view'
    }),

    created () {
      this.$store.dispatch('companyasset/list/setFilter', {company: this.$route.params.company})
    },

    methods: {
      ...mapActions({
        getPage: 'companyasset/list/default'
      }),
      createAsset () {
        return {name: 'CompanyAssetCreate', params: { company: this.$route.params.company }}
      }
    }
  }
</script>
<template>
  <list-view store="companyasset" :add-route="createAsset" edit-route="CompanyAssetUpdate">
    <template v-slot:header="slotProps">
      <b-col md="10"><strong>{{ $t('companyasset.filename.label') }}</strong></b-col>
    </template>
    <template v-slot:item="slotProps">
      <b-col md="10">{{ slotProps.item.filename }}</b-col>
    </template>
    <template v-slot:buttons="slotProps">
      <b-button :to="{name: 'CompanyAssetShow', params: { id: slotProps.item['@id'] }}">
        <span>Show</span>
      </b-button>
    </template>
  </list-view>
</template>
